import React from 'react';
import { connect } from 'react-redux';

const Details = props => {
  const { category } = props;
  const createDescriptionMarkup = () => {
    return {'__html': category.details}
  }
  return (
    <div style={{padding: '20px'}}>
      <div dangerouslySetInnerHTML={createDescriptionMarkup()}></div>
      {/* <p>
        In goal of this section is to give short overview of entire category
        </p>
        <p>
        This section is not for marketing reason, but for reason of helping dealer to quickly understand
        which machine is better match for his requirements
        </p>
        <p>
        For example for precision planters there can be placed short description of every seen elemnt SP, MTR, REGINA ... with direct references
        to models and also explanation which machine is better for different seeding conditions (prepared soild, minimum seeding, e.t.c) - similar
        that we have in product range books
        </p>
        <p>Some pictures also can be placed here for explanation reasons</p>
      <p>Some tables with different models comparison can also be presented here</p> */}
    </div>
  );
}

export default connect(
  state => ({
    category: state.category[state.ui.category],
  })
)(Details);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/category/category-info/details.js